/** Normalize API member or join-request row for CommunityMemberProfileDialog. */
export const mapCommunityMemberProfile = (source) => {
  if (!source) return null;

  const profileSource =
    source.requester && typeof source.requester === 'object'
      ? source.requester
      : source.user && typeof source.user === 'object'
        ? source.user
        : source;

  return {
    fullName:
      profileSource.fullName ?? profileSource.name ?? source.fullName ?? source.name ?? 'Member',
    avatarUrl: profileSource.avatarUrl ?? source.avatarUrl ?? undefined,
    userEmail:
      profileSource.userEmail ?? profileSource.email ?? source.userEmail ?? source.email ?? '',
    profession:
      profileSource.profession ?? profileSource.role ?? source.profession ?? source.role ?? '',
    interests: Array.isArray(profileSource.interests)
      ? profileSource.interests.filter(Boolean)
      : Array.isArray(source.interests)
        ? source.interests.filter(Boolean)
        : [],
    gender: profileSource.gender ?? source.gender ?? '',
    phoneNumber:
      profileSource.phoneNumber ?? profileSource.phone ?? source.phoneNumber ?? source.phone ?? '',
  };
};
